import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookPowerCheckTab extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          power_checks: {},
          aircraft_logbook_id: this.props.aircraft_logbook_id,
          flight_report_power_check_id: '',
          engine: '',
          altitude: '',
          external_temperature: '',
          power_turbine_rotation_rate: '',
          engine_power_rate: '',
          gas_turbine_rotation_rate: '',
          engine_temperature: '',
          engine_temperature_margin: '',
          gas_turbine_torque_margin: '',
        };
      }

      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }
    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }

      // LM
      componentWillReceiveProps(newProps) {
        if(this.state.loaded === 0) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            loaded: 1,
          });
        }

        if(typeof newProps.power_checks !== 'undefined' && newProps.power_checks !== null && this.state.loaded === 1) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            power_checks: newProps.power_checks,
          });
        }
      }
    
      render() {
        var self = this;
        return (
    <div>
      <RequestApi ref={'request_api'} />
        <h3 className="page-title pull-left">Power Check</h3>
        <div className="clearfix"></div>
        <hr/>
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-striped">
            <caption>Power Checks</caption>
            <thead>
              <tr>
                {/* <th rowSpan={2} className="text-center vcenter">Flight</th> */}
                <th rowSpan={2} className="text-center vcenter">Engine</th>
                <th rowSpan={2} className="text-center vcenter">Altitude</th>
                <th rowSpan={2} className="text-center vcenter">OAT</th>
                <th rowSpan={2} className="text-center vcenter">N2/NR</th>
                <th rowSpan={2} className="text-center vcenter">Torque</th>
                <th rowSpan={2} className="text-center vcenter">N1/NG</th>
                <th rowSpan={2} className="text-center vcenter">T4/T5/ITT/TOT/MGT (°C)</th>
                <th colSpan={2} className="text-center vcenter">Margins</th>
              </tr>
              <tr>
                <th className="text-center vcenter">T5/ITT/T4/TOT/MGT (°C)</th>
                <th className="text-center vcenter">NG/Torque</th>
              </tr>
            </thead>
              <tbody id="power_checks">
                {Object.keys(self.state.power_checks).map(function(k) {
                  var power_check = self.state.power_checks[k];
                  return(
                    <tr className="text-center" key={power_check.id}>
                      {/* <td>{power_check.flight_report_power_check_id}</td> */}
                      <td>{power_check.engine}</td>
                      <td>{power_check.altitude}</td>
                      <td>{power_check.external_temperature}</td>
                      <td>{power_check.power_turbine_rotation_rate}</td>
                      <td>{power_check.engine_power_rate}</td>
                      <td>{power_check.gas_turbine_rotation_rate_decimal}</td>
                      <td>{power_check.engine_temperature}</td>
                      <td>{power_check.engine_temperature_margin}</td>
                      <td>{power_check.gas_turbine_torque_margin_decimal}</td>
                    </tr>
                  );
                })}
              </tbody>
          </table>
        </div>
    </div>
    );
  }
}

export default AircraftLogbookPowerCheckTab;


// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookPowerCheckTab.js